/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createTan } from '../../factoriesAny.js';
export var tanDependencies = {
  typedDependencies,
  createTan
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesTan.generated.js
// module id = Z6Sk
// module chunks = 3